import _findIndex from "lodash/findIndex";
import { AnyAction } from "redux";
import * as AT from "./actionTypes";
import { UpdatePortingDateState } from "../../../../models/state";

const fulfilled = (actionType: string) => {
    return `${actionType}_FULFILLED`;
};

const initialState: UpdatePortingDateState = {
    subscriptions: [],
    holidays: {},
    updated: {
        isPerformed: false,
        success: [],
        failed: [],
        invalid: [],
    },
    creationDate: undefined,
};

const updateSubscriptions = (state: UpdatePortingDateState, action: AnyAction) => {
    const index = _findIndex(state.subscriptions, (sub) => sub.guid === action.guid);
    if (index < 0) {
        return state;
    }

    const subscriptions = state.subscriptions;
    const updateSubscription = {
        ...subscriptions[index],
        portingInfo: {
            ...subscriptions[index].portingInfo,
            newDate: action.date,
        },
    };

    return {
        ...state,
        subscriptions: [...subscriptions.slice(0, index), updateSubscription, ...subscriptions.slice(index + 1)],
    };
};

const reducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case fulfilled(AT.UPD_UPDATE_PORTING_DATES):
            return {
                ...state,
                updated: {
                    isPerformed: true,
                    success: action.payload.success,
                    failed: action.payload.failed,
                    invalid: action.payload.invalid,
                },
            };
        case AT.UPD_SET_SELECTED_DATE:
            return updateSubscriptions(state, action);
        default:
            return state;
    }
};

export default reducer;
